export default "__VITE_ASSET__0HhsmTwC__"